
import BrodBandPostPaidcomp from "../../components/brodbandpostpaid/BrodBandPostPaid"
export const MobilePostPaid = ({ title_1, title_2, title }) => {
   
    return <div>
        <BrodBandPostPaidcomp title_1={title_1} title_2={title_2} title={title} />
    </div>
}